import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from "react-router-dom";

const Warning = ({ config, appRedirect, appWarning }) => {
    const timeoutLength = config.timeout.timeout_warning_length;
    const [timer, setTimer] = useState(timeoutLength);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(seconds => seconds - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [appWarning]);

    if (appRedirect) return <Redirect to='/' push />;
    return (
        <div className='redirect__warning'>
            <div className="redirect__warning-inner">
                {config.timeout.timeout_text} {timer}
            </div>
        </div>
    );
};

Warning.propTypes = {
    appRedirect: PropTypes.bool,
    appWarning: PropTypes.bool,
};

export default Warning;
